// Chatbot integration config for R0AM by Wadiah Mutual.
//
// provider "demo": the built-in multilingual demo chatbot is used (front-end only,
// payloads logged to console). The structure below is intentionally provider-agnostic
// so external chatbots can be plugged in later WITHOUT touching component code:
//   - Typebot   (recommended first external provider) -> set typebotId + typebotUrl
//   - Dify      (advanced AI workflows / RAG / quote logic) -> set difyUrl + difyToken
//   - Chatwoot  (live human support / WhatsApp / campaigns) -> set chatwoot* values
// See /app/INTEGRATIONS_ROADMAP.md for the full migration plan.
//
// IMPORTANT: never place private API keys or HubSpot tokens here. This bundle ships
// to a static Hostinger site. HubSpot sync must happen server-side inside mutualautomation.
export const chatbotConfig = {
  provider: process.env.REACT_APP_PUBLIC_CHATBOT_PROVIDER || "demo",
  enabled: true,
  demoMode: (process.env.REACT_APP_PUBLIC_CHATBOT_PROVIDER || "demo") === "demo",
  typebotId: process.env.REACT_APP_PUBLIC_TYPEBOT_ID || "",
  typebotUrl: process.env.REACT_APP_PUBLIC_TYPEBOT_URL || "",
  difyUrl: process.env.REACT_APP_PUBLIC_DIFY_URL || "",
  difyToken: process.env.REACT_APP_PUBLIC_DIFY_TOKEN || "",
  chatwootBaseUrl: process.env.REACT_APP_PUBLIC_CHATWOOT_BASE_URL || "",
  chatwootWebsiteToken: process.env.REACT_APP_PUBLIC_CHATWOOT_WEBSITE_TOKEN || "",
  mutualAutomationApiBase: process.env.REACT_APP_PUBLIC_MUTUALAUTOMATION_API_BASE || "",
  hubspotFutureSync: true,
  supportedLanguages: ["en", "es", "pt", "fr", "ar"],
};

// Front-end lead scoring (placeholder logic until mutualautomation owns it).
export function scoreLead(p) {
  const countries = (p.countries_next_12_months || []).filter(Boolean);
  const isHNW = p.customer_segment === "executive_hnw" || p.customer_segment === "entourage";
  const isTrader = p.customer_segment === "trader_conference";
  const annual = p.payment_preference === "annual";

  const high_value_lead =
    (p.traveler_count || 0) >= 4 ||
    isHNW ||
    isTrader ||
    p.risk_options_interest === true ||
    countries.length >= 3 ||
    annual;

  const requires_assisted_review =
    p.pre_existing_disclosure === true ||
    p.risk_options_interest === true ||
    (p.traveler_count || 0) >= 4 ||
    isHNW;

  return { high_value_lead, requires_assisted_review, future_hubspot_sync: chatbotConfig.hubspotFutureSync };
}

export const AGE_RANGES = ["18–30", "31–45", "46–60", "60+"];
